<script setup>
import * as iotapi from "../iotapi.js";
import { ref, onMounted, computed } from "vue";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const chart = ref(null);

const props = defineProps({
  indicador: Object,
  unidad: String,
  min: Number,
  max: Number,
});

const labels = computed(() => {
  let labels = [];
  props.indicador.timeinstant.forEach((valor) => {
    switch (props.indicador.calculationfrequency) {
      case "yearly":
        labels.push(iotapi.parseDateApi(valor).getFullYear());
        break;
      default:
        labels.push(iotapi.parseDateApi(valor).toLocaleString());
    }
  });
  return labels;
});

const t = (key) => {
  return iotapi.i18next.t(key);
};
const exists = (key) => {
  return iotapi.i18next.exists(key);
};

onMounted(() => {
  new Chart(chart.value, {
    type: "line",
    data: {
      labels: labels.value,
      datasets: [
        {
          fill: "origin",
          label: props.unidad || iotapi.i18next.t("smart.valor"),
          data: props.indicador.kpivalue,
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 2,
        },
      ],
    },
    options: {
      responsive: true,
      scales: {
        y: {
          beginAtZero: false,
          min: props.min,
          max: props.max,
          grace: "20%",
        },
      },
      plugins: {
        legend: {
          position: "top",
        },
      },
    },
  });
});
</script>

<template>
  <li class="col-md-6">
    <div>
      <div class="shadow-lg text-center my-4 p-3">
        <p class="sim_h5 bold mt-0 mb-1 text-center">{{ t("smart.indicadores." + indicador.id + "_tit") }}</p>
        <p>{{ t("smart.indicadores." + indicador.id + "_des") }}</p>
        <canvas ref="chart"></canvas>
        <p class="small mt-1 mb-0" v-if="exists('smart.indicadores.' + indicador.id + '_pie')">
          {{ t("smart.indicadores." + indicador.id + "_pie") }}
        </p>
      </div>
    </div>
  </li>
</template>
